import { render, staticRenderFns } from "./MatrAdd.vue?vue&type=template&id=27c7d8ee&scoped=true&"
import script from "./MatrAdd.vue?vue&type=script&lang=js&"
export * from "./MatrAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c7d8ee",
  null
  
)

export default component.exports